import { render, staticRenderFns } from "./EditFinalAsset.vue?vue&type=template&id=16937388&scoped=true&"
import script from "./EditFinalAsset.vue?vue&type=script&lang=js&"
export * from "./EditFinalAsset.vue?vue&type=script&lang=js&"
import style0 from "./EditFinalAsset.vue?vue&type=style&index=0&id=16937388&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16937388",
  null
  
)

export default component.exports